import {
  createContext,
  useState,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface LoaderContextProps {
  isAILoaderLoading: boolean;
  setIsAILoaderLoading: Dispatch<SetStateAction<boolean>>;
  AILoaderMessage: string | null;
  setAILoaderMessage: Dispatch<SetStateAction<string | null>>;
  /** Show loader with optional message */
  showAILoader: (message?: string) => void;
  /** Clear loader and reset message */
  clearAILoader: () => void;
}

const AILoaderContext = createContext<LoaderContextProps | undefined>(
  undefined
);

export const AILoaderProvider = ({ children }: { children: ReactNode }) => {
  const [isAILoaderLoading, setIsAILoaderLoading] = useState(false);
  const [AILoaderMessage, setAILoaderMessage] = useState<string | null>(null);

  const showAILoader = (message?: string) => {
    setAILoaderMessage(message || null);
    setIsAILoaderLoading(true);
  };

  const clearAILoader = () => {
    setIsAILoaderLoading(false);
    setAILoaderMessage(null);
  };

  return (
    <AILoaderContext.Provider
      value={{
        isAILoaderLoading,
        setIsAILoaderLoading,
        AILoaderMessage,
        setAILoaderMessage,
        showAILoader,
        clearAILoader,
      }}
    >
      {children}
    </AILoaderContext.Provider>
  );
};

export const useAILoader = (): LoaderContextProps => {
  const context = useContext(AILoaderContext);
  if (context === undefined) {
    throw new Error("useAILoader must be used within an AILoaderProvider");
  }
  return context;
};

export default AILoaderContext;
